import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { get } from '../../../core/client';
import { IGetEventData, IResult, IGetCalendar } from './model';

export const getOnCalendarEvents: any = createAsyncThunk('calendar/getCalendar', async (dates: IGetCalendar) => {
    const _startDate = new Date(dates.startDate);
    const _endDate = new Date(dates.endDate);
    const startDate = new Date(_startDate.setMonth(_startDate.getMonth() - 1));
    const endDate = new Date(_endDate.setMonth(_endDate.getMonth() + 1));

    const month = endDate.getMonth() + 1;
    const day = endDate.getDate();

    const smonth = startDate.getMonth() + 1;
    const sday = startDate.getDate();
    const syear = startDate.getFullYear();
    const eyear = smonth >= 8 ? syear + 1 : syear;
    const date = eyear + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
    const sdate = syear + '-' + (smonth < 10 ? '0' + smonth : smonth) + '-' + (sday < 10 ? '0' + sday : sday);
    const calendarData = await get<IResult>(`user-specialdate-main/calendar-list?StartDate=${sdate}&EndDate=${date}`);

    return calendarData;
});

export const getBulletin: any = createAsyncThunk('bulletin/getBulletin', async () => {
    const bulletinData = await get<IResult>('bulletin/get-all-bulletin');
    return bulletinData;
});

export const getDepartments: any = createAsyncThunk('user/getDepartments', async () => {
    const departmentsData = await get<any>('users/get-user-departments');
    return departmentsData;
});

export const getAllEmployees: any = createAsyncThunk('users/getAllEmployees', async () => {
    const allEmployees = await get<any>('users/get-user-all-employees');
    return allEmployees;
});

export const getUserTeams: any = createAsyncThunk('user/getUserTeams', async () => {
    const userTeams = await get<any>('users/get-user-teams');
    return userTeams;
});

export const getTutorial: any = createAsyncThunk('jumbotron/jumbotronList', async () => {
    const tutorial = await get<any>('jumbotron/list');
    return tutorial;
});

export const getEvents: any = createAsyncThunk('personcard/getPersonCard', async (data: IGetEventData) => {
    let url = 'users/get-special-day-cards-async-new';
    if (data.specialDate) {
        const month = data.specialDate.getMonth() + 1;
        const day = data.specialDate.getDate();
        const year = data.specialDate.getFullYear();
        const date = year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);

        const queryParam = (url.includes('?') ? '&' : '?') + 'SpecialDate=' + date;
        url = url + queryParam;
    }
    if (data.timeType) {
        const queryParam = (url.includes('?') ? '&' : '?') + 'TimeType=' + data.timeType;
        url = url + queryParam;
    }
    if (data.userSearchType) {
        const queryParam = (url.includes('?') ? '&' : '?') + 'UserSearchType=' + data.userSearchType;
        url = url + queryParam;
    }
    if (data.search) {
        const queryParam = (url.includes('?') ? '&' : '?') + 'Search=' + data.search;
        url = url + queryParam;
    }
    if (data.isTeam !== null) {
        const queryParam = (url.includes('?') ? '&' : '?') + 'IsTeam=' + data.isTeam;
        url = url + queryParam;
    }
    if (data.specialDateType) {
        const queryParam = (url.includes('?') ? '&' : '?') + 'SpecialDateType=' + data.specialDateType;
        url = url + queryParam;
    }

    const personCardData = await get<IResult>(url);
    return personCardData;
});

export const getHelpAssistance: any = createAsyncThunk('help/jumbotronList', async () => {
    const helpAssistance = await get<any>('localization/get-application-help-constant?paltform=WEB');
    return helpAssistance;
});

export const getSpecialDateNameList: any = createAsyncThunk('users/get-special-time-list', async () => {
    const specialDateNameList = await get<any>('/users/get-special-time-list');
    return specialDateNameList;
});

export const getSpecialNameList: any = createAsyncThunk('users/get-special-name-list', async () => {
    const specialNameList = await get<any>('/users/get-special-date-name-list');
    return specialNameList;
});

const momentsSlice = createSlice({
    name: 'moments',
    initialState: {
        bulletin: {
            loading: true,
            items: [],
        },
        calendarEvents: {
            loading: true,
            items: [],
        },
        filter: {
            search: '',
            specialDate: null,
            timeType: 35,
            userSearchType: 1,
            specialDateType: '',
            isTeam: null,
        },
        eventList: {
            loading: true,
            items: [],
            feedUsersPhoto: [],
        },
        aside: {
            departments: [],
            departmentsLoading: true,
            userTeams: [],
            userTeamsLoading: true,
            allEmployees: [],
            allEmployeesLoading: true,
            teamsAvarage: 0,
        },
        page: {
            name: 'momentsHome',
            type: '',
            id: '',
            managerDefinedSpecialDateId: null,
            userSpecialDateMainId: null,
            index: 0,
        },
        tutorial: {
            loading: true,
            items: [],
        },
        specialNameList: {
            loading: true,
            items: [],
        },

        tuttorialIndex: 0,

        helpAssistance: {},

        helpAsistanceAll: {
            loading: true,
            items: [],
        },
        specialDateNameList: {
            loading: true,
            items: [],
        },
        selectedOptions: []
    },

    reducers: {
        setFilter(state, action) {
            state.filter = action.payload;
        },
        setPage(state, action) {
            state.page = action.payload;
        },
        decrement: state => {
            state.tuttorialIndex -= 1;
        },
        increment: (state, action) => {
            state.tuttorialIndex += action.payload;
        },
        tuttorialClose: state => {
            state.tuttorialIndex = null;
        },
        tuttorialIndexStart: (state, action) => {
            state.tuttorialIndex = action.payload;
        },
        setSelectedOptions: (state, action) => {
            state.selectedOptions = action.payload;
        },
    },

    extraReducers: builder => {
        builder.addCase(getOnCalendarEvents.fulfilled, (state, action: PayloadAction<IResult>) => {
            state.calendarEvents.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.calendarEvents.loading = false;
        });
        builder.addCase(getBulletin.fulfilled, (state, action: PayloadAction<IResult>) => {
            state.bulletin.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.bulletin.loading = false;
        });
        builder.addCase(getEvents.pending, (state, action: PayloadAction<IResult>) => {
            state.eventList.loading = true;
        });
        builder.addCase(getEvents.fulfilled, (state, action: PayloadAction<any>) => {
            state.eventList.items = action.payload.isSuccessful ? action.payload.result.specialDateCardResponse : [];
            state.eventList.feedUsersPhoto = action.payload.isSuccessful ? action.payload.result.photoWithUserDto : [];
            state.eventList.loading = false;
        });
        builder.addCase(getDepartments.fulfilled, (state, action: PayloadAction<any>) => {
            state.aside.departments = action.payload.isSuccessful ? action.payload.result.items : [];
            state.aside.departmentsLoading = false;
        });
        builder.addCase(getAllEmployees.fulfilled, (state, action: PayloadAction<any>) => {
            state.aside.allEmployees = action.payload.isSuccessful ? action.payload.result.items : [];
            state.aside.allEmployeesLoading = false;
        });
        builder.addCase(getUserTeams.fulfilled, (state, action: PayloadAction<any>) => {
            state.aside.userTeams = action.payload.isSuccessful ? action.payload.result.items : [];
            state.aside.teamsAvarage = action.payload.result.average;
            state.aside.userTeamsLoading = false;
        });
        builder.addCase(getTutorial.fulfilled, (state, action: PayloadAction<any>) => {
            state.tutorial.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.tutorial.loading = false;
        });
        builder.addCase(getSpecialNameList.fulfilled, (state, action: PayloadAction<any>) => {
            state.specialNameList.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.specialNameList.loading = false;
        });
        builder.addCase(getHelpAssistance.fulfilled, (state, action: PayloadAction<any>) => {
            if (action.payload.isSuccessful) {
                state.helpAsistanceAll.loading = false;
                state.helpAsistanceAll.items = action.payload.result.items;
                const helpAsist = {};
                for (let i = 0; i < action.payload.result.items.length; i++) {
                    const element: any = action.payload.result.items[i];
                    helpAsist[element.key] = element.value;
                }
                state.helpAssistance = helpAsist;
            }
        });
        builder.addCase(getSpecialDateNameList.fulfilled, (state, action: PayloadAction<any>) => {
            state.specialDateNameList.items = action.payload.isSuccessful ? action.payload.result.items : [];
            state.specialDateNameList.loading = false;
        });
    },
});

export const { setFilter, setPage, decrement, increment, tuttorialIndexStart, tuttorialClose,setSelectedOptions } = momentsSlice.actions;
export default momentsSlice.reducer;
